"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openConfirmDialog = void 0;
const react_1 = __importDefault(require("react"));
const modals_1 = require("@mdigital/components/dist/utils/modals");
const utils_1 = require("../../../common/utils");
const openConfirmDialog = (props) => {
    modals_1.ModalsService.showBasicModal({
        title: props.title,
        icon: undefined,
        body: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: props.description } }))),
        close: {
            title: (0, utils_1.getSingleText)('app.cancel'),
            disableOutsideClick: false,
            hideCloseIcon: true,
            disableEscapeKey: false,
            callback: undefined,
            priority: 'tertiary',
        },
        submit: {
            title: props.confirmText,
            callback: props.confirmCallback,
            shouldAutoClose: true,
            destructive: props.destructive,
        },
        isCentered: false,
        size: 'small',
    });
};
exports.openConfirmDialog = openConfirmDialog;
